import React from "react";
import { Box, Button, Paper } from "@mui/material";
import CustomerDetailEntry from "./CustomerDetailEntry";

export default function CustomerTab(props) {
  const { customer } = props;

  return (
    <Box>
      <Paper elevation={0}>
        <Box px={2} py={3}>
          <CustomerDetailEntry
            customer={customer}
            onChange={(o) => {
              props.onChange(o);
            }}
          />
        </Box>
      </Paper>
      <Box my={2}>
        <Button color="primary" variant="contained" fullWidth onClick={() => props.onSubmit()}>
          CONTINUE
        </Button>
      </Box>
    </Box>
  );
}
